import React, { useContext } from "react";
import { IntlContext } from "context";
import { Check, CheckCheck } from "lucide-react";

interface Props {
    messageOrFile: JSX.Element;
    dateTime: string;
    isModerateMessage: boolean;
    isRead: boolean;
    showReadIndicator: boolean;
}

const DiscussionMyMessage: React.FC<Props> = ({
    messageOrFile,
    dateTime,
    isModerateMessage,
    isRead,
    showReadIndicator,
}) => {
    const intl = useContext(IntlContext);

    return (
        <div className="flex justify-end mb-3 px-4">
            <div className="max-w-[72%]">
                <div className="bg-primary text-primary-foreground rounded-2xl rounded-br-sm px-4 py-2.5 text-sm leading-relaxed shadow-sm">
                    {messageOrFile}
                </div>
                <div className="flex items-center justify-end gap-2 mt-1">
                    <span className="text-xs text-muted-foreground">{dateTime}</span>
                    {isModerateMessage && (
                        <span className="text-xs text-amber-600">
                            {intl.formatMessage("booking.messages.label.message_moderated")}
                        </span>
                    )}
                    {showReadIndicator && (
                        <span className="flex items-center" title={isRead ? "Lu" : "Envoyé"}>
                            {isRead ? <CheckCheck size={16} /> : <Check size={16} />}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DiscussionMyMessage;
